export function purgeAnyBoomerangVideos() {
  const boomerangVideoBackgrounds = document.getElementsByTagName('boomerang-video-background');
  if (boomerangVideoBackgrounds.length > 0) {
    console.warn('🐬 Found boomerang video backgrounds:', boomerangVideoBackgrounds);
    for (const boomerangVideoBackground of boomerangVideoBackgrounds) {
      boomerangVideoBackground.remove();
    }
  }
}
